module.exports = __webpack_public_path__ + "static/media/46.31f38ee4.jpg";